import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[adsptStepWizardTitle]' })
export class StepWizardTitleDirective {
  constructor(readonly tr: TemplateRef<any>) {}
}
